/**
 * @generated SignedSource<<d1d2b727be07055ff31e989f3294146f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "StemTransferResponse",
    "kind": "LinkedField",
    "name": "stmApply",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hash",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseStmPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseStmPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a6693cad5b2bf504b0e91c5223f2266",
    "id": null,
    "metadata": {},
    "name": "ImpulseStmPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseStmPaymentCheckoutPagesMutation(\n  $request: StmRequestInput\n) {\n  stmApply(request: $request) {\n    hash\n  }\n}\n"
  }
};
})();

node.hash = "9c770b5b4eebe22e97114a6541d5d9c0";

module.exports = node;
